/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_AddCustomerNoteRequest } from '../models/Routemize_DTOs_AddCustomerNoteRequest';
import type { Routemize_DTOs_AddCustomerNoteResponse } from '../models/Routemize_DTOs_AddCustomerNoteResponse';
import type { Routemize_DTOs_AttachmentsDTO } from '../models/Routemize_DTOs_AttachmentsDTO';
import type { Routemize_DTOs_BookingFormDetailExternalDTO } from '../models/Routemize_DTOs_BookingFormDetailExternalDTO';
import type { Routemize_DTOs_ConfirmBookingRequest } from '../models/Routemize_DTOs_ConfirmBookingRequest';
import type { Routemize_DTOs_ConfirmBookingResponse } from '../models/Routemize_DTOs_ConfirmBookingResponse';
import type { Routemize_DTOs_ConfirmRescheduleResponse } from '../models/Routemize_DTOs_ConfirmRescheduleResponse';
import type { Routemize_DTOs_DeleteBookingAttachmentResponse } from '../models/Routemize_DTOs_DeleteBookingAttachmentResponse';
import type { Routemize_DTOs_DeleteQuestionAttachmentResponse } from '../models/Routemize_DTOs_DeleteQuestionAttachmentResponse';
import type { Routemize_DTOs_GetBookingFormContextResponse } from '../models/Routemize_DTOs_GetBookingFormContextResponse';
import type { Routemize_DTOs_GetBookingPreviewRequest } from '../models/Routemize_DTOs_GetBookingPreviewRequest';
import type { Routemize_DTOs_GetBookingPreviewResponse } from '../models/Routemize_DTOs_GetBookingPreviewResponse';
import type { Routemize_DTOs_GetLandingPageContextResponse } from '../models/Routemize_DTOs_GetLandingPageContextResponse';
import type { Routemize_DTOs_InitiateBookingRequest } from '../models/Routemize_DTOs_InitiateBookingRequest';
import type { Routemize_DTOs_PublicConfirmRescheduleRequest } from '../models/Routemize_DTOs_PublicConfirmRescheduleRequest';
import type { Routemize_DTOs_PublicRescheduleContextDTO } from '../models/Routemize_DTOs_PublicRescheduleContextDTO';
import type { Routemize_DTOs_SaveServiceDetailsRequest } from '../models/Routemize_DTOs_SaveServiceDetailsRequest';
import type { Routemize_DTOs_SaveStepResponse } from '../models/Routemize_DTOs_SaveStepResponse';
import type { Routemize_DTOs_SchedulingResponse } from '../models/Routemize_DTOs_SchedulingResponse';
import type { Routemize_DTOs_SendPhoneVerificationCodeRequest } from '../models/Routemize_DTOs_SendPhoneVerificationCodeRequest';
import type { Routemize_DTOs_SendPhoneVerificationCodeResponse } from '../models/Routemize_DTOs_SendPhoneVerificationCodeResponse';
import type { Routemize_DTOs_SlotSuggestionDTO } from '../models/Routemize_DTOs_SlotSuggestionDTO';
import type { Routemize_DTOs_UpdateAppointmentAccessCodeRequest } from '../models/Routemize_DTOs_UpdateAppointmentAccessCodeRequest';
import type { Routemize_DTOs_UpdateBookingPhoneNumberRequest } from '../models/Routemize_DTOs_UpdateBookingPhoneNumberRequest';
import type { Routemize_DTOs_UpdateContactAddressRequest } from '../models/Routemize_DTOs_UpdateContactAddressRequest';
import type { Routemize_DTOs_UpdateSchedulingPreferencesRequest } from '../models/Routemize_DTOs_UpdateSchedulingPreferencesRequest';
import type { Routemize_DTOs_UploadBookingAttachmentsResponse } from '../models/Routemize_DTOs_UploadBookingAttachmentsResponse';
import type { Routemize_DTOs_UploadQuestionAttachmentsResponse } from '../models/Routemize_DTOs_UploadQuestionAttachmentsResponse';
import type { Routemize_DTOs_VerifyPhoneCodeRequest } from '../models/Routemize_DTOs_VerifyPhoneCodeRequest';
import type { Routemize_DTOs_VerifyPhoneCodeResponse } from '../models/Routemize_DTOs_VerifyPhoneCodeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PublicBookingFormService {
    /**
     * @param bookingFormId
     * @returns Routemize_DTOs_BookingFormDetailExternalDTO OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetBookingFormDetail(
        bookingFormId: string,
    ): CancelablePromise<Routemize_DTOs_BookingFormDetailExternalDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getBookingFormDetail/{bookingFormId}',
            path: {
                'bookingFormId': bookingFormId,
            },
        });
    }
    /**
     * @param bookingFormId
     * @param existingRequestId
     * @returns Routemize_DTOs_GetBookingFormContextResponse OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetBookingFormContext(
        bookingFormId: string,
        existingRequestId?: string,
    ): CancelablePromise<Routemize_DTOs_GetBookingFormContextResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getBookingFormContext',
            query: {
                'BookingFormId': bookingFormId,
                'ExistingRequestId': existingRequestId,
            },
        });
    }
    /**
     * @param slug
     * @param existingRequestId
     * @returns Routemize_DTOs_GetBookingFormContextResponse OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetBookingFormContextBySlug(
        slug: string,
        existingRequestId?: string,
    ): CancelablePromise<Routemize_DTOs_GetBookingFormContextResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getBookingFormContextBySlug',
            query: {
                'Slug': slug,
                'ExistingRequestId': existingRequestId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SaveStepResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormInitiateBookingRequest(
        requestBody?: Routemize_DTOs_InitiateBookingRequest,
    ): CancelablePromise<Routemize_DTOs_SaveStepResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/initiateBookingRequest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SaveStepResponse OK
     * @throws ApiError
     */
    public static putApiAppPublicBookingFormUpdateContactAddress(
        requestBody?: Routemize_DTOs_UpdateContactAddressRequest,
    ): CancelablePromise<Routemize_DTOs_SaveStepResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/publicBookingForm/updateContactAddress',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SaveStepResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormSaveServiceDetails(
        requestBody?: Routemize_DTOs_SaveServiceDetailsRequest,
    ): CancelablePromise<Routemize_DTOs_SaveStepResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/saveServiceDetails',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_GetBookingPreviewResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormCreateBookingPreview(
        requestBody?: Routemize_DTOs_GetBookingPreviewRequest,
    ): CancelablePromise<Routemize_DTOs_GetBookingPreviewResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/createBookingPreview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_ConfirmBookingResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormConfirmBooking(
        requestBody?: Routemize_DTOs_ConfirmBookingRequest,
    ): CancelablePromise<Routemize_DTOs_ConfirmBookingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/confirmBooking',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_AddCustomerNoteResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormAddCustomerNote(
        requestBody?: Routemize_DTOs_AddCustomerNoteRequest,
    ): CancelablePromise<Routemize_DTOs_AddCustomerNoteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/addCustomerNote',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SendPhoneVerificationCodeResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormSendPhoneVerificationCode(
        requestBody?: Routemize_DTOs_SendPhoneVerificationCodeRequest,
    ): CancelablePromise<Routemize_DTOs_SendPhoneVerificationCodeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/sendPhoneVerificationCode',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_VerifyPhoneCodeResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormVerifyPhoneCode(
        requestBody?: Routemize_DTOs_VerifyPhoneCodeRequest,
    ): CancelablePromise<Routemize_DTOs_VerifyPhoneCodeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/verifyPhoneCode',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SendPhoneVerificationCodeResponse OK
     * @throws ApiError
     */
    public static putApiAppPublicBookingFormUpdatePhoneNumberAndResend(
        requestBody?: Routemize_DTOs_UpdateBookingPhoneNumberRequest,
    ): CancelablePromise<Routemize_DTOs_SendPhoneVerificationCodeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/publicBookingForm/updatePhoneNumberAndResend',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestId
     * @returns Routemize_DTOs_AttachmentsDTO OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetBookingAttachments(
        requestId: string,
    ): CancelablePromise<Array<Routemize_DTOs_AttachmentsDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getBookingAttachments/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @param formData
     * @returns Routemize_DTOs_UploadBookingAttachmentsResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormUploadBookingAttachments(
        requestId: string,
        formData?: {
            files?: Array<Blob>;
        },
    ): CancelablePromise<Routemize_DTOs_UploadBookingAttachmentsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/uploadBookingAttachments/{requestId}',
            path: {
                'requestId': requestId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestId
     * @param attachmentId
     * @returns Routemize_DTOs_DeleteBookingAttachmentResponse OK
     * @throws ApiError
     */
    public static deleteApiAppPublicBookingFormDeleteBookingAttachment(
        requestId: string,
        attachmentId: string,
    ): CancelablePromise<Routemize_DTOs_DeleteBookingAttachmentResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/publicBookingForm/deleteBookingAttachment',
            query: {
                'RequestId': requestId,
                'AttachmentId': attachmentId,
            },
        });
    }
    /**
     * @param requestId
     * @param questionId
     * @param formData
     * @returns Routemize_DTOs_UploadQuestionAttachmentsResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormUploadQuestionAttachments(
        requestId?: string,
        questionId?: string,
        formData?: {
            files?: Array<Blob>;
        },
    ): CancelablePromise<Routemize_DTOs_UploadQuestionAttachmentsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/uploadQuestionAttachments',
            query: {
                'requestId': requestId,
                'questionId': questionId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestId
     * @param questionId
     * @returns Routemize_DTOs_AttachmentsDTO OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetQuestionAttachments(
        requestId?: string,
        questionId?: string,
    ): CancelablePromise<Array<Routemize_DTOs_AttachmentsDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getQuestionAttachments',
            query: {
                'requestId': requestId,
                'questionId': questionId,
            },
        });
    }
    /**
     * @param requestId
     * @param questionId
     * @param attachmentId
     * @returns Routemize_DTOs_DeleteQuestionAttachmentResponse OK
     * @throws ApiError
     */
    public static deleteApiAppPublicBookingFormDeleteQuestionAttachment(
        requestId: string,
        questionId: string,
        attachmentId: string,
    ): CancelablePromise<Routemize_DTOs_DeleteQuestionAttachmentResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/publicBookingForm/deleteQuestionAttachment',
            query: {
                'RequestId': requestId,
                'QuestionId': questionId,
                'AttachmentId': attachmentId,
            },
        });
    }
    /**
     * @param requestId
     * @returns Routemize_DTOs_SlotSuggestionDTO OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetBookingSlots(
        requestId: string,
    ): CancelablePromise<Array<Routemize_DTOs_SlotSuggestionDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getBookingSlots/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @returns Routemize_DTOs_SchedulingResponse OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetBookingSlotsWithResponse(
        requestId: string,
    ): CancelablePromise<Routemize_DTOs_SchedulingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getBookingSlotsWithResponse/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param slug
     * @returns Routemize_DTOs_GetLandingPageContextResponse OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetLandingPageContextBySlug(
        slug: string,
    ): CancelablePromise<Routemize_DTOs_GetLandingPageContextResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getLandingPageContextBySlug',
            query: {
                'Slug': slug,
            },
        });
    }
    /**
     * @param landingPageId
     * @returns Routemize_DTOs_GetLandingPageContextResponse OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetLandingPageContext(
        landingPageId?: string,
    ): CancelablePromise<Routemize_DTOs_GetLandingPageContextResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getLandingPageContext',
            query: {
                'LandingPageId': landingPageId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SaveStepResponse OK
     * @throws ApiError
     */
    public static putApiAppPublicBookingFormUpdateSchedulingPreferences(
        requestBody?: Routemize_DTOs_UpdateSchedulingPreferencesRequest,
    ): CancelablePromise<Routemize_DTOs_SaveStepResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/publicBookingForm/updateSchedulingPreferences',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SaveStepResponse OK
     * @throws ApiError
     */
    public static putApiAppPublicBookingFormUpdateAppointmentAccessCode(
        requestBody?: Routemize_DTOs_UpdateAppointmentAccessCodeRequest,
    ): CancelablePromise<Routemize_DTOs_SaveStepResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/publicBookingForm/updateAppointmentAccessCode',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param appointmentId
     * @returns Routemize_DTOs_PublicRescheduleContextDTO OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetRescheduleContext(
        appointmentId: string,
    ): CancelablePromise<Routemize_DTOs_PublicRescheduleContextDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getRescheduleContext/{appointmentId}',
            path: {
                'appointmentId': appointmentId,
            },
        });
    }
    /**
     * @param appointmentId
     * @param preferredDate
     * @param preferredSecondaryDate
     * @param preferredTimeRange
     * @param isAsap
     * @param isFlexible
     * @returns Routemize_DTOs_SchedulingResponse OK
     * @throws ApiError
     */
    public static getApiAppPublicBookingFormGetRescheduleSlots(
        appointmentId: string,
        preferredDate?: string,
        preferredSecondaryDate?: string,
        preferredTimeRange?: string,
        isAsap?: boolean,
        isFlexible?: boolean,
    ): CancelablePromise<Routemize_DTOs_SchedulingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/publicBookingForm/getRescheduleSlots',
            query: {
                'AppointmentId': appointmentId,
                'PreferredDate': preferredDate,
                'PreferredSecondaryDate': preferredSecondaryDate,
                'PreferredTimeRange': preferredTimeRange,
                'IsAsap': isAsap,
                'IsFlexible': isFlexible,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_ConfirmRescheduleResponse OK
     * @throws ApiError
     */
    public static postApiAppPublicBookingFormConfirmReschedule(
        requestBody?: Routemize_DTOs_PublicConfirmRescheduleRequest,
    ): CancelablePromise<Routemize_DTOs_ConfirmRescheduleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/publicBookingForm/confirmReschedule',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
